import { render, staticRenderFns } from "./dashboardView.vue?vue&type=template&id=56ff4c6a&"
import script from "./dashboardView.vue?vue&type=script&lang=js&"
export * from "./dashboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports